module.exports = __webpack_public_path__ + "static/media/work3.d71a2729.webp";